import { Box } from "@chakra-ui/react";
import { vinculoColorToken } from "../utils/vinculoColors";

// Marcador da cor do vínculo. Decorativo: o nome do vínculo sempre aparece ao lado.
export default function VinculoColorDot({ cor, size = "10px", ...rest }) {
  return (
    <Box
      as="span"
      display="inline-block"
      flexShrink={0}
      boxSize={size}
      borderRadius="full"
      bg={vinculoColorToken(cor)}
      aria-hidden
      data-testid="vinculo-color-dot"
      data-cor={cor}
      {...rest}
    />
  );
}
